import { LoadLecturerDetailAsync, ShowMyCartSummaryAsync } from './aka.js';
export async function mainlektor() {
  console.log('LoadLecturerDetail');
  await LoadLecturerDetailAsync(1);
  await ShowMyCartSummaryAsync();
}
